import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import { TeamData } from 'Types/SRITypes';

type Props = {
  teamRankLoading?: boolean,
  teamDetailsData: TeamData
} | typeof defaultProps;

const defaultProps = {
  teamRankLoading: false,
  teamDetailsData: {} as TeamData,
};

const TeamDetails = function TeamDetails(props: Props) {
  const { teamRankLoading, teamDetailsData } = props;
  const {
    team_name: name, team_lead_details: details,
    team_members_count: count,
  } = teamDetailsData;
  return (
    <div className="team-details">
      {teamRankLoading
        ? (
          <>
            {[1, 2, 3].map(() => <SkeletonCustom height="20px" width="150px" diameter="4px" margin="0 20px 0 0" />)}
          </>
        )
        : (
          <>
            {name ? (
              <div>
                Team Name:
                <span>{name}</span>
              </div>
            ) : null}
            {details ? (
              <div>
                Team Lead:
                <span>{details.team_lead_name}</span>
              </div>
            ) : null}
            {count ? (
              <div>
                No. of Members:
                <span>{count}</span>
              </div>
            ) : null}
          </>
        )}

    </div>
  );
};

TeamDetails.defaultProps = defaultProps;
export default TeamDetails;
